import { ConversationDialogueActions } from '../interfaces';
import { NotificationServiceActionTypes } from './event-notifications.service-method.type';

export const NOTIFICATION_ACTION_HANDLERS: {
  [key: string]: ConversationDialogueActions;
} = {
  'com.dntl.1l2c.invite_to_project': {
    confirmAction: NotificationServiceActionTypes.APPROVE_PROJECT_PARTICIPATION,
    rejectAction: NotificationServiceActionTypes.REJECT_PROJECT_PARTICIPATION,
  },
  'com.dntl.1l2c.request_to_join_project': {
    confirmAction: NotificationServiceActionTypes.APPROVE_PROJECT_PARTICIPATION,
    rejectAction: NotificationServiceActionTypes.REJECT_PROJECT_PARTICIPATION,
  },
  'com.dntl.1l2c.user_get_connection_invitation': {
    confirmAction: NotificationServiceActionTypes.CONFIRM_CONNECTION,
    rejectAction: NotificationServiceActionTypes.REJECT_CONNECTION,
  },
  'com.dntl.1l2c.invite_to_community': {
    confirmAction: NotificationServiceActionTypes.ACCEPT_COMMUNITY_PARTICIPATION,
    rejectAction: NotificationServiceActionTypes.REJECT_COMMUNITY_PARTICIPATION,
  },
  'com.dntl.1l2c.request_to_join_community': {
    confirmAction: NotificationServiceActionTypes.ACCEPT_COMMUNITY_PARTICIPATION,
    rejectAction: NotificationServiceActionTypes.REJECT_COMMUNITY_PARTICIPATION,
  },
  'com.dntl.1l2c.doctor_patient_link_added': {
    confirmAction: NotificationServiceActionTypes.ACCEPT_DOCTOR_PATIENT_LINK,
    rejectAction: NotificationServiceActionTypes.REJECT_DOCTOR_PATIENT_LINK,
  },
  'com.dntl.1l2c.user_updated_reactivation_petition': {
    confirmAction: NotificationServiceActionTypes.REVERT_ACCOUNT_REACTIVATION,
    rejectAction: NotificationServiceActionTypes.DECLINE_ACCOUNT_REACTIVATION,
  },
};
